export const SECTION_TITLES = {
  ALL: '전체',
  PLANNING: '기획전',
  BEST_SELLERS: '베스트',
  SPECIAL_OFFERS: '이달의 할인',
  NEW_PRODUCTS: '신상품',
  REVIEWS: '상품후기',
  COUPON: '쿠폰',
} as const;

export const SECTION_SLOGANS = {
  ALL: '다양한 상품을 한곳에 모아봤어요.',
  PLANNING: '지금이 가장 맛있는 식품들을 소개드려요!',
  BEST_SELLERS: '지금 가장 많이 팔리고 있는 상품들',
  SPECIAL_OFFERS: '오늘의 한정 특가를 놓치지 마세요!',
  NEW_PRODUCTS: '새로 들어온 상품들을 소개합니다.',
  REVIEWS: '믿고 먹는 식품에 대해 생생한 후기를 만나보세요',
  COUPON: '다양한 할인 혜택을 놓치지 마세요!',
} as const;
